import { render } from "./flipBookmark.vue?vue&type=template&id=42ab3c8b"
import script from "./flipBookmark.vue?vue&type=script&lang=js"
export * from "./flipBookmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__